import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ImgUploadInput from "./ImgUploadInput";
import clsx from "clsx";
import useCategories from "../hooks/useCategories";
import useAxios from "../hooks/useAxios";
import useProducts from "../hooks/useProducts";
import { useTheme } from "../context/ThemeContext";
import Toggle from "react-toggle";
import imgUrl from "../util/imgUrl";
import Pagination from "./Pagination";
import OrdersCreateFiltersForm from "./Forms/Orders/OrdersCreateFiltersForm";

const initialManualItemData = {
    name: '',
    image: null,
    file: null,
    provider_name: null,
    quantity: 0,
    description: '',
    price: 0,
    category_id: '',
    subject: '',
    fee_for_formulating: false,
    authorized_by: '',
    account: '',
    seven: ''
};

const initialMonthlyItemData = {
    product_id: '',
    quantity: 0,
    subject: ''
};

const UpdateOrderItemModal = ({ order, orderItem, onSave, setShow, show }) => {

    const { background } = useTheme();

    const [data, setData] = useState(order?.orderTypeId === 3 ? initialManualItemData : initialMonthlyItemData);

    const [categoriesFilters, setCategoriesFilters] = useState({
        page: 1,
        perPage: 10,
        path: '',
        orderBy: 'path,ASC'
    });

    const [filters, setFilters] = useState({
        serviceId: '',
        name: '',
        reference: '',
        providerName: '',
        code: '',
        page: 1,
        subCategoryId: '',
        orderBy: 'name,ASC',
        categoryId: '',
        perPage: 18
    });

    const [currentCategories, setCurrentCategories] = useState([]);

    const [{ products, numberOfPages: productsNumberOfPages, loading: loadingProducts }, getProducts] = useProducts({ params: { ...filters }, options: { manual: true, useCache: false } });

    const [{ categories, numberOfPages, loading: loadingCategories }, getCategories] = useCategories({ params: categoriesFilters, options: { manual: true, useCache: false } });

    const [{ loading: updateLoading }, updateOrderItem] = useAxios({ url: `/order-items/${orderItem?.id}`, method: 'POST' }, { manual: true, useCache: false });

    useEffect(() => {
        if (show && order?.orderTypeId === 3) getCategories();
    }, [categoriesFilters, show, order?.orderTypeId])

    useEffect(() => {
        if (show && order?.orderTypeId !== 3) getProducts();
    }, [filters, show, order?.orderTypeId])

    useEffect(() => {
        setCurrentCategories(old => [...old, ...categories]);
    }, [categories])

    useEffect(() => {
        if (!show) {
            setData(order?.orderTypeId === 3 ? initialManualItemData : initialMonthlyItemData)
        } else {
            var dataToSet = order?.orderTypeId === 3 ? initialManualItemData : initialMonthlyItemData;

            Object.keys(dataToSet).forEach((key) => {
                if (key == 'provider_name') {
                    dataToSet[key] = orderItem?.providerName || null;
                } else if (key == 'fee_for_formulating') {
                    dataToSet[key] = Boolean(orderItem?.feeForFormulating);
                } else if (key == 'authorized_by') {
                    dataToSet[key] = orderItem?.authorizedBy || '';
                } else if (key == 'account') {
                    dataToSet[key] = orderItem?.account || '';
                } else if (key == 'seven') {
                    dataToSet[key] = orderItem?.seven || '';
                } else {
                    dataToSet[key] = orderItem?.[key] || null;
                }
            });

            setData((old) => {
                return {
                    ...old,
                    ...dataToSet
                }
            });
        }
    }, [show, order?.orderTypeId, orderItem]);

    const handleChange = (e) => {
        setData((oldData) => {
            return {
                ...oldData,
                [e.target.name]: e.target.type === 'file' ? e?.target?.files?.[0] : (e.target.type === 'checkbox' ? e.target.checked : e.target.value)
            }
        });
    }

    const handleSubmit = (e) => {

        e.preventDefault?.();

        const dataToSend = new FormData();

        Object.keys(data).map((key) => {
            if (data?.[key] !== undefined && data?.[key] !== null && data?.[key] !== '') {
                if (key == 'file' || key == 'image') {
                    if (data?.[key]?.name) {
                        dataToSend?.append(key, data?.[key], data?.[key]?.name);
                    }
                } else if (typeof data?.[key] === 'boolean') {
                    dataToSend?.append(key, data?.[key] ? 1 : 0);
                } else {
                    dataToSend?.append(key, data?.[key]);
                }
            } else if (key === 'fee_for_formulating') {
                dataToSend?.append(key, 0);
            }
        })

        updateOrderItem({ data: dataToSend }).then((response) => {
            onSave?.(response?.data?.data);
        })
    }

    const handlePage = (page) => {
        setFilters((old) => ({ ...old, page }));
    }

    return (
        <Modal size="xl" className="fade" show={show}>
            <Modal.Header>
                <Modal.Title>{orderItem?.name}</Modal.Title>
                <Button
                    variant=""
                    className="btn-close"
                    onClick={() => setShow?.(false)}
                >
                </Button>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit} className="row align-items-center">
                    {
                        order?.orderTypeId == 3 ?
                            <>
                                <div className="col-md-12 mb-4">
                                    <div className="d-flex align-items-center justify-content-between p-3 border rounded">
                                        <label className="m-0 fw-bold">
                                            Cobro por formular:
                                        </label>
                                        <Toggle
                                            checked={Boolean(data?.fee_for_formulating)}
                                            onChange={() => setData(old => ({ ...old, fee_for_formulating: !old?.fee_for_formulating }))}
                                        />
                                    </div>
                                </div>
                                {
                                    data?.fee_for_formulating ? (
                                        <div className="col-md-12 mb-4">
                                            <div className="row p-3 border rounded">
                                                <div className="col-md-4 form-group mb-2">
                                                    <label>Autorizado por</label>
                                                    <input
                                                        type="text"
                                                        value={data?.authorized_by || ''}
                                                        name="authorized_by"
                                                        className="form-control"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="col-md-4 form-group mb-2">
                                                    <label>Cuenta</label>
                                                    <input
                                                        type="text"
                                                        value={data?.account || ''}
                                                        name="account"
                                                        className="form-control"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="col-md-4 form-group mb-2">
                                                    <label>Cebe</label>
                                                    <input
                                                        type="text"
                                                        value={data?.seven || ''}
                                                        name="seven"
                                                        className="form-control"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ) : null
                                }
                                <div className="col-md-12 mb-5">
                                    <h3 className="text-center">
                                        Información del producto
                                    </h3>
                                </div>
                                <div className="col-md-6 form-group mb-4">
                                    <ImgUploadInput
                                        name="image"
                                        style={{
                                            width: '100px',
                                            height: '100px'
                                        }}
                                        value={data?.image}
                                        previewImage={orderItem?.imagePath}
                                        description="imagen"
                                        deleteButton={data?.image}
                                        change={handleChange}
                                    />
                                </div>
                                <div className="col-md-6 text-center form-group mb-4">
                                    <label>Documento</label>
                                    <div className="text-center">
                                        <label
                                            htmlFor={`file-input`}
                                            className={clsx("btn", {
                                                "btn-danger": !data?.file,
                                                "btn-success": data?.file,
                                            })}
                                            title="Cargar Archivo"
                                        >
                                            <i className="flaticon-022-copy"></i>
                                        </label>
                                        {
                                            data?.file &&
                                            <>
                                                <p style={{ margin: 0 }} title={data?.file?.name}>
                                                    {data?.file?.name?.length > 20 ? `${data?.file?.name?.slice(0, 20)}...` : data?.file?.name}
                                                </p>
                                                <button
                                                    type="button" onClick={() => handleChange({ target: { files: [''], type: 'file', name: 'file' } })}
                                                    className="text-danger btn"
                                                    title="Remover Archivo"
                                                >
                                                    X
                                                </button>
                                            </>
                                        }
                                        <input
                                            type="file"
                                            name="file"
                                            accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,image/*"
                                            className="form-control d-none"
                                            id={`file-input`}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 form-group mb-4">
                                    <label>Nombre</label>
                                    <input placeholder="nombre" autoFocus value={data?.name} onChange={handleChange} name="name" type="text" className="form-control" />
                                </div>
                                <div className="col-md-6 form-group mb-4">
                                    <label>Precio Referencia</label>
                                    <input placeholder="precio" value={data?.price} onChange={handleChange} name="price" type="number" className="form-control" />
                                </div>
                                <div className="col-md-6 form-group mb-4">
                                    <label>Proveedor</label>
                                    <input
                                        placeholder="proveedor"
                                        value={data?.provider_name}
                                        type="text"
                                        className="form-control"
                                        name="provider_name"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-6 form-group mb-4">
                                    <label>Cantidad</label>
                                    <input
                                        placeholder="cantidad"
                                        value={data?.quantity}
                                        type="text"
                                        className="form-control"
                                        name="quantity"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-12 form-group mb-3">
                                    <label>Descripción</label>
                                    <textarea
                                        rows={4}
                                        value={data?.description}
                                        style={{ minHeight: '100px' }}
                                        className="form-control"
                                        name="description"
                                        onChange={handleChange}
                                        placeholder="descripción"
                                    />
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="row align-items-center mb-1">
                                        <div className="col-md-6">
                                            <label className="fw-bold">
                                                Categoría
                                            </label>
                                            <p>
                                                Valor actual: {orderItem?.category?.path || 'Sin categoría'}
                                            </p>
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Buscar..."
                                                value={categoriesFilters?.path}
                                                onChange={(e) => {
                                                    setCurrentCategories([]);
                                                    setCategoriesFilters(old => ({ ...old, path: e.target.value, page: 1 }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <ul class="list-group" style={{ maxHeight: 300, overflow: 'auto' }}>
                                        {
                                            currentCategories?.map((category, i) => {
                                                const level = category?.path?.split("->").length - 1;
                                                return (
                                                    <li class="list-group-item py-1">
                                                        <input
                                                            class={`form-check-input me-1 ms-${level > 0 ? level + 1 : 0}`}
                                                            type="checkbox"
                                                            checked={data?.category_id == category?.id}
                                                            value={category?.id}
                                                            onChange={() => setData(old => ({ ...old, category_id: category?.id }))}
                                                            id={`category-check-${category?.id}`}
                                                        />
                                                        <label
                                                            class={`form-check-label ${level === 0 ? 'fw-bold text-primary' : 'fw-bold'}`}
                                                            for={`category-check-${category?.id}`}
                                                        >
                                                            {category?.path}
                                                        </label>
                                                    </li>
                                                )
                                            })
                                        }
                                        {
                                            !loadingCategories && currentCategories?.length < 1 ?
                                                <li class="list-group-item text-center">
                                                    No se encontrarón resultados.
                                                </li>
                                                :
                                                null
                                        }
                                        {
                                            loadingCategories ?
                                                <li class="list-group-item text-center">
                                                    <div class="spinner-border text-primary" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </li>
                                                :
                                                null
                                        }
                                        {
                                            !loadingCategories && numberOfPages > categoriesFilters?.page ?
                                                <li class="list-group-item text-center">
                                                    <button
                                                        onClick={() => setCategoriesFilters((old) => ({ ...old, page: old?.page + 1 }))}
                                                        type="button"
                                                        className="btn btn-primary"
                                                    >
                                                        Cargar más
                                                    </button>
                                                </li>
                                                :
                                                null
                                        }
                                    </ul>
                                </div>
                            </>
                            :
                            <>
                                <div className="col-md-12 form-group mb-3">
                                    <label>Cantidad</label>
                                    <input
                                        placeholder="cantidad"
                                        value={data?.quantity}
                                        type="text"
                                        className="form-control"
                                        name="quantity"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <div className="col-12 mb-5">
                                        <h1 className="text-center">
                                            Productos
                                        </h1>
                                        <OrdersCreateFiltersForm
                                            filters={filters}
                                            setFilters={setFilters}
                                        />
                                        <div className="row align-items-center position-relative">
                                            {
                                                products?.length > 0 ?
                                                    products?.map((product, i) => {
                                                        return (
                                                            <div className="col-md-2 mb-3">
                                                                <div
                                                                    className="rounded mb-3 shadow position-relative product-card-container"
                                                                    onClick={() => handleChange({ target: { value: product?.id, name: 'product_id' } })}
                                                                    style={{ cursor: 'pointer', overflow: 'hidden', background: background?.value === 'light' ? 'white' : '#171622' }}
                                                                >
                                                                    {
                                                                        data?.product_id === product?.id ?
                                                                            <p style={{ marginBottom: 0, position: 'absolute', fontSize: 18, top: 5, right: 15 }}>
                                                                                ✔️
                                                                            </p>
                                                                            :
                                                                            null
                                                                    }
                                                                    <img
                                                                        src={imgUrl(product?.imagePath)}
                                                                        className="border-bottom border-primary"
                                                                        alt="" style={{ objectFit: 'cover', height: 120, width: '100%' }}
                                                                    />
                                                                    <div className="p-2" style={{ position: 'relative' }}>
                                                                        <div className="product-card-complete-name text-center position-absolute text-white bg-primary" style={{ width: '100%', left: 0, bottom: '100%' }}>
                                                                            {product?.name}
                                                                        </div>
                                                                        <h6 title={product?.name} className="text-truncate mt-2 position-relative" style={{ width: '100%' }}>
                                                                            {product?.name}
                                                                        </h6>

                                                                        <b className="text-primary">{product?.code}</b>

                                                                        <div className="text-truncate">
                                                                            <b>{product?.category?.name || ''}</b>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    !loadingProducts &&
                                                    <div className="text-center mt-3 h4">
                                                        No se encontrarón productos.
                                                    </div>
                                            }
                                            {
                                                loadingProducts &&
                                                <div className="text-center position-absolute d-flex align-items-center justify-content-center top-0 left-0 w-100 h-100 border border-primary" style={{ background: 'rgba(255,255,255, .4)' }}>
                                                    <div class="spinner-border text-primary" role="status" style={{ width: 80, height: 80 }}>
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <Pagination
                                            onBack={handlePage}
                                            onNext={handlePage}
                                            currentPage={filters?.page}
                                            numberOfPages={numberOfPages}
                                            onClickPage={handlePage}
                                        />
                                    </div>
                                </div>
                            </>
                    }

                    <div className="col-md-12 mb-3">
                        <label htmlFor="subject">
                            Motivo
                            <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            id="subject"
                            name="subject"
                            className="form-control"
                            placeholder="Motivo"
                            value={data?.subject}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-12 text-end">
                        <button disabled={updateLoading} className="btn btn-success">
                            {
                                updateLoading ?
                                    'Cargando...'
                                    :
                                    'Modificar'
                            }
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default UpdateOrderItemModal;